const AUTH_PREFIX = 'auth.'

export const AUTH_PERMISSIONS = {
  readRole: AUTH_PREFIX + 'can-read-role',
  modifyRole: AUTH_PREFIX + 'can-modify-role',
  deleteRole: AUTH_PREFIX + 'can-delete-role',
  readRolePermission: AUTH_PREFIX + 'can-read-role_permission',
  modifyRolePermission: AUTH_PREFIX + 'can-modify-role_permission',
  readUser: AUTH_PREFIX + 'can-read-user',
  modifyUser: AUTH_PREFIX + 'can-modify-user',
  deleteUser: AUTH_PREFIX + 'can-delete-user',
  createUser: AUTH_PREFIX + 'can-add-user',
  modifyUserRole: AUTH_PREFIX + 'can-modify-user_role',
  readApplicationSettings: AUTH_PREFIX + 'can-read-application_settings',
  modifyApplicationSettings: AUTH_PREFIX + 'can-modify-application_settings',
  deleteApplicationSettings: AUTH_PREFIX + 'can-delete-application_settings'
}
